export const MODULE_OVERVIEW = 'Overview';
export const MODULE_CUSTOM_DASHBOARD = 'Custom Dashboard';
export const MODULE_DATA_EXTRACTOR = 'Data Extractor';
export const MODULE_ADVANCED_ANALYTICS = 'Advanced Analytics';
export const MODULE_DATA_MANAGEMENT = 'Data Management';
export const MODULE_PEOPLE_HUB_EMPLOYEES = 'PeopleHubEmployees';
export const MODULE_PEOPLE_HUB_PAYROLL = 'PeopleHubPayroll';
export const MODULE_SAM = 'sam';
export const MODULE_BDESE = 'BDESE';
export const MODULE_INDEX_MW = 'IndexMW';
export const MODULE_PAYROLL_FORECAST = 'PayrollForecast';
export const MODULE_PEOPLE_HUB_ORG_CHART = 'PeopleHubOrgChart';
export const MODULE_PEOPLE_HUB_EMPLOYEES_PROFILE = 'PeopleHubEmployeesProfile';
export const MODULE_DATA_MANAGEMENT_QUALITY = 'DataManagementQuality';
export const MODULE_DATA_MANAGEMENT_LEXICON = 'DataManagementLexicon';
export const MODULE_DATA_MANAGEMENT_IMPORTS = 'DataManagementImports';
export const MODULE_DATA_MANAGEMENT_MAPPING = 'DataManagementMappingNormalization';
export const MODULE_COMPENSATION = 'Compensation';

export const PERMISSION_VALUE_ALL = 'ALL';

export const DEFAULT_MODULE_ACCESS = Object.freeze({
  [MODULE_OVERVIEW]: false,
  [MODULE_CUSTOM_DASHBOARD]: false,
  [MODULE_DATA_EXTRACTOR]: false,
  [MODULE_PEOPLE_HUB_EMPLOYEES]: false,
  [MODULE_PEOPLE_HUB_PAYROLL]: false,
  [MODULE_ADVANCED_ANALYTICS]: false,
  [MODULE_DATA_MANAGEMENT]: false,
  [MODULE_SAM]: false,
  [MODULE_BDESE]: false,
  [MODULE_INDEX_MW]: false,
  [MODULE_PAYROLL_FORECAST]: false,
  [MODULE_PEOPLE_HUB_ORG_CHART]: false,
  [MODULE_PEOPLE_HUB_EMPLOYEES_PROFILE]: false,
  [MODULE_DATA_MANAGEMENT_QUALITY]: false,
  [MODULE_DATA_MANAGEMENT_LEXICON]: false,
  [MODULE_DATA_MANAGEMENT_IMPORTS]: false,
  [MODULE_DATA_MANAGEMENT_MAPPING]: false,
  [MODULE_COMPENSATION]: false,
});

export const ALL_MODULES_GRANTED = Object.freeze(
  Object.fromEntries(Object.keys(DEFAULT_MODULE_ACCESS).map((key) => [key, true]))
);

export const DATA_ACCESS_PEOPLE = 'people';
export const DATA_ACCESS_PAY = 'pay';
